<template>
    <div class="ask-answer-log-wrapper scroll-tracker">
        <div class="ask-answer-panel">
            <div class="title-wrapper">
                <div class="ask-log-title" v-if="!islikeLog">{{ title }}</div>
                <TranslateDropdown v-if="!islikeLog" :translateText="translateBtn" :selectedType="selectedTranslateType" @click="quesTranslate" />
            </div>
            <div class="data-panel-content">
                <LogOperationBar
                    class="log-content-opeat"
                    :islikeLog="islikeLog"
                    @updateTime="updateTime"
                    @updateLogData="updateLogData"
                    @updateSearchType="updateSearchType"
                />
                <div class="table-top-message">
                    <RoundButton v-show="showExport" @btnClick="exportHandler" :text="exportLabel"></RoundButton>
                    <el-tooltip v-show="showExport" class="btn-export-wrapper" content="查看导出记录" placement="bottom">
                        <div><i class="btn-export" @click="toExportDetail" /></div>
                    </el-tooltip>
                    <div class="show-total">
                        {{ $t("zhiji.robotLog.unrepeatedUserCount") }}<span class="log-num">{{ unrepeatedUserCount }}</span>
                    </div>
                    <div class="show-total">
                        {{ $t("zhiji.robotLog.putQuestionTotal") }}<span class="log-num">{{ questionCount }}</span>
                    </div>
                    <div class="show-total">
                        {{ $t("zhiji.robotLog.handQuestionTotal") }}<span class="log-num">{{ handQuestionTotal }}</span>
                    </div>
                    <div class="show-total">
                        {{ $t("zhiji.robotLog.clickQuestionTotal") }}<span class="log-num">{{ clickQuestionTotal }}</span>
                    </div>
                    <div class="show-total" v-if="islikeLog">
                        {{ $t("zhiji.robotLog.likeCount") }}<span class="log-num">{{ likeCount }}</span>
                    </div>
                    <div class="show-total" v-if="islikeLog">
                        {{ $t("zhiji.robotLog.dislikeCount") }}<span class="log-num">{{ dislikeCount }}</span>
                    </div>
                </div>
                <Table class="log-table-list" :config="tableConfig" :dataset="tableData" :loading="isTranslating" :loadingText="loadingText" @columnClick="tableColumnClick" />
            </div>
        </div>
        <div class="page-control" v-show="logTotal >= 10">
            <PageControl :total="logTotal" :curPage="curPage" :lengthRank="pageLengthRank" :pageLength="10" @pageChange="pageChange" />
        </div>
    </div>
</template>

<script>
import LogOperationBar from "./components/LogOperationBar";
import TranslateDropdown from "@/views/zhiji/bComponents/buttons/TranslateDropdown.vue";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Table from "@/views/zhiji/bComponents/newTable/Table.vue";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import ChatDetailModal from "./components/ChatDetailModal";
import { askLogTable } from "./askAnswerLogConfig.js";
import QuestionEditModal from "@/views/zhiji/components/questionEdit/QuestionEditModal";
import RobotExportExcel from "./components/export/RobotExportExcel";
import { sseRequest } from '@/views/zhiji/js/services/service.js'
import * as service from "./service";
import checkAuth from "@/lib/auth";

export default {
    name: "AskAnswerLogPage",
    components: {
        LogOperationBar,
        Table,
        RoundButton,
        PageControl,
        TranslateDropdown,
    },
    props: ["pageType"],
    data() {
        return {
            logType: this.pageType === "likeLog" ? "likeLog" : "qaLog", // 日志的类型 qa_log 问答日志（默认）like_log 赞踩日志
            curPage: 1,
            curPageLen: 10,
            pageLengthRank: 10,
            logData: {
                tableData: [],
                count: 0,
                userCount: 0,
                inputCount: 0,
                clickCount: 0,
                unrepeatedUserCount: 0,
                questionCount: 0,
                likeCount: 0,
                dislikeCount: 0,
            },
            reqData: {},
            startTime: this.zhiji.dateFormat(new Date(), "YYYY-MM-DD 00:00"),
            endTime: this.zhiji.dateFormat(new Date()),
            searchType: "all",
            selectedTranslateType: "", // 默认不选中任何翻译类型
            isTranslating: false, // 翻译加载状态
            translateIconHover: "url(" + this.zhiji.staticPath() + "translate-hover-icon.png)",
            translateIcon: "url(" + this.zhiji.staticPath() + "translate-normal-icon.png)",
            loadingText:'翻译中...'
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.robotLog.askAnswerLog");
        },
        exportLabel() {
            return this.$t("zhiji.common.export");
        },
        translateBtn() {
            return this.$t("zhiji.common.translatePage")
        },
        tableConfig() {
            return askLogTable(this.logType);
        },
        tableData() {
            return this.logData.tableData
        },
        logTotal() {
            return parseInt(this.logData.count);
        },
        withoutFirstAnswerTotal() {
            return this.logData.userCount;
        },
        handQuestionTotal() {
            return this.logData.inputCount;
        },
        clickQuestionTotal() {
            return this.logData.clickCount;
        },
        unrepeatedUserCount() {
            return this.logData.unrepeatedUserCount;
        },
        questionCount() {
            return this.logData.questionCount;
        },
        likeCount() {
            return this.logData.likeCount;
        },
        dislikeCount() {
            return this.logData.dislikeCount;
        },
        islikeLog() {
            return this.pageType === "likeLog";
        },
        showExport() {
            return this.pageType === "likeLog" ? true : checkAuth("analysisrobot.log.export");
        }
    },
    watch: {
        exportLabel() {
            this.getAskLogData();
        }
    },
    mounted() {
        this.getAskLogData();
    },
    methods: {
        getAskLogData() {
            let reqData = {
                startDate: this.startTime,
                endDate: this.endTime,
                curPage: this.curPage,
                size: this.curPageLen,
                searchType: this.searchType,
                logType: this.logType,
                clickId: this.clickId,
                translateLang: this.$i18n.locale == "cn" ? "zh" : "en"
            };
            this.reqData = reqData;
            this.getRespLogData(reqData);
        },
        getRespLogData(reqData) {
            this.zhiji.requestByServiceName("queryAskAnswerLog", reqData).then(result => {
                this.logData.count = result.count;
                this.logData.userCount = result.userCount;
                this.logData.inputCount = result.inputCount;
                this.logData.clickCount = result.clickCount;
                this.logData.likeCount = result.likeCount;
                this.logData.dislikeCount = result.dislikeCount;
                this.logData.tableData.splice(0, this.logData.tableData.length, ...result.tableData);
                this.logData.unrepeatedUserCount = result.unrepeatedUserCount;  // 去重用户量
                this.logData.questionCount = result.questionCount;  // 提问总数
            });
        },
        tableColumnClick(data) {
            if (data.colId == "operate") {
                this.$store.dispatch("zhiji/showModal", {
                    type: ChatDetailModal,
                    data: {
                        userId: data.rowData.addData.userId,
                        answerDetail: data.rowData.addData.answerDetail,
                        enAnswerDetail: data.rowData.addData.enAnswerDetail,
                        lang: data.rowData.addData.lang,
                        startDate: this.startTime,
                        endDate: this.endTime,
                        sessionId: data.rowData.addData.sessionId,
                        accountId: data.rowData.addData.accountId,
                        userQuestion: data.rowData.addData.userQuestion,
                        createTime: data.rowData.addData.createTime,
                    }
                });
            } else if (data.colId == "standQuestion" && data.rowData.columns[7].data) {
                const currentGameId = this.$store.state.zhiji.gameState.gameId;
                const questionGameId = data.rowData.addData.gameId;
                if (currentGameId != questionGameId) {
                    // 匹配标问不属于当前业务库
                    return;
                };
                this.$store.dispatch("zhiji/showModal", {
                    type: QuestionEditModal,
                    data: {
                        questionId: data.rowData.addData.questionId,
                        sceneId: data.rowData.addData.sceneId,
                        curPanel: "AnswerPanel",
                        saveHandler: () => {
                            this.getRespLogData(this.reqData);
                        },
                    }
                });
            }
        },
        exportHandler() {
            this.zhiji.requestByServiceName("byDownRobotExport", this.reqData).then(res => {
                res &&
                    this.$message({
                        message: "操作成功，可以点击查看导出记录按钮查看导出进度！",
                        type: "success"
                    });
            });
        },
        toExportDetail() {
            const reqData = {
                logType: this.logType,
            };
            this.$store.dispatch("zhiji/showModal", {
                type: RobotExportExcel,
                data: {
                    title: "导出记录",
                    getExport: param => this.zhiji.requestByServiceName("getRobotExportList", { ...reqData, ...param })
                }
            });
        },
        updateSearchType(data) {
            this.searchType = data;
        },
        updateLogData(data) {
            this.reqData = {
                ...data,
                logType: this.logType,
            };
            this.curPage = data.curPage;
            this.curPageLen = data.curPageLen;
            let timeDiffer = new Date(this.reqData.endDate) - new Date(this.reqData.startDate);
            timeDiffer > 0 && this.getRespLogData(this.reqData);
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.reqData.curPage = data.curPage;
            this.reqData.curPageLen = data.pageLength;

            this.getRespLogData(this.reqData);
        },
        updateTime({ startTime, endTime }) {
            this.startTime = startTime;
            this.endTime = endTime;
        },
        async quesTranslate(type) {
            this.selectedTranslateType = String(type);
            this.isTranslating = true;
            
            const translateData = {};
            const textArrary = this.getStrText();
            
            try {
                if (type === "3") {
                    const hunYuanQuery = {
                        target: this.$i18n.locale == "cn" ? "zh" : "en",
                        list: textArrary
                    };
                    await sseRequest({
                        apiPath: '/xiaoyue-operation/stream/batchTranslateByHunYuan',
                        ...hunYuanQuery,
                        onMessage: (event) => {
                            const data = JSON.parse(event.data);
                            if (data.is_end) {
                               this.getRespLogData(this.reqData);
                               this.isTranslating = false;
                            }
                        },
                    });
                } else {
                    // 使用其他翻译服务
                    const bath_query = {
                        list: textArrary,
                        from: "",
                        to: this.$i18n.locale == "cn" ? "zh" : "en",
                        server_type: type
                    };
                    translateData.list = await service.batch_translate(bath_query).then(()=>{
                        this.getRespLogData(this.reqData);
                        this.isTranslating = false;
                    });
                }
            } catch (error) {
                this.$message.error('翻译失败，请重试');
            }
        },
        getStrText() {
            const strArrary = [];
            this.logData.tableData.forEach(function(item) {
                const obj = {};
                obj.id =  item.translateId
                obj.content = item.userQuestion;
                strArrary.push(obj);
            });
            return strArrary;
        }
    }
};
</script>

<style lang="less" scoped>
.ask-answer-log-wrapper {
    height: 100%;
    padding: 16px 16px 16px 16px;
    background: #f2f7fb;
    overflow-y: auto;
    box-sizing: border-box;

    .ask-answer-panel {
        padding: 0 24px 24px 24px;
        background: #ffffff;
        border: 1px solid #d9e4ef;
        border-radius: 4px;
        .title-wrapper {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #e1eaf2;
            .ask-log-title {
                padding: 16px 0 20px;
                font-size: 14px;
                color: #41475e;
                line-height: 20px;
                font-weight: bold;
            }
            .translate-btn {
                margin-top: 12px;
            }
        }

        .table-top-message {
            padding: 8px 20px;
            background: #f2f7fb;
            border-width: 1px 1px 0 1px;
            border-style: solid;
            border-color: #e3ecf5;
            display: flex;

            .show-total {
                height: 32px;
                line-height: 32px;

                .log-num {
                    color: #00c972;
                    margin-right: 50px;
                }
            }
            .show-total:first-of-type {
                margin-left: 42px;
            }
            .btn-export-wrapper {
                margin-top: 8px;
                margin-right: 29px;
                .btn-export {
                    display: block;
                    width: 20px;
                    height: 20px;
                    background: url("@{zhijiStaticImagePath}class-spr.png") no-repeat;
                    background-position: 1px -115px;
                    &:hover {
                        background-position: -64px -114px;
                        cursor: pointer;
                    }
                }
            }
        }

        .log-table-list {
            border-width: 0 1px 1px 1px;
            border-style: solid;
            border-color: #e3ecf5;
            box-sizing: border-box;
        }
    }

    .page-control {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
    }
}
</style>
